module.exports = __webpack_public_path__ + "static/media/IMG_0289.cc0c0e7f.jpg";